import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'

// API PascalCase doner (Startup.cs: PropertyNamingPolicy = null).
export interface ICardConsentView {
  Status: number
  /** Sunucudaki şablondan üretilen beyan metni (HTML). */
  LongText: string | null
  /** Beyan metninin altında gösterilen KVKK aydınlatma metni (HTML). */
  KvkkText: string | null
  Amount: number | null
  Currency: string | null
  CardMask: string | null
  DealerTitle: string | null
  Message: string | null
}

export interface ICardConsentApproveResponse {
  MaskedPhone: string
  /** Doğrulama kodu SMS ile gelmez; onaydan sonra bu yanıtla sayfada gösterilir. */
  Code: string
}

// Backend CardPhoneVerificationStatus ile aynı; -1 geçersiz/tükenmiş bağlantı.
export const CONSENT_STATUS_LINK_SENT = 0
export const CONSENT_STATUS_CONSENTED = 1

/**
 * Son kullanıcının SMS linkinden ulaştığı uçlar. Oturum GEREKTİRMEZ —
 * backend tarafında [Ignore] ile LoginFilter atlanır.
 */
export class CardConsentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: '',
      requesterInfo,
    })
  }

  public async get(token: string): Promise<ICardConsentView> {
    this.props.url = `cardConsent/${token}`
    return await this.getAsync<ICardConsentView>()
  }

  public async approve(token: string): Promise<ICardConsentApproveResponse> {
    this.props.url = `cardConsent/${token}/approve`
    return await this.postAsync<ICardConsentApproveResponse>({})
  }
}
